export enum SitemapVersionType {
    TwoDimensional = "TwoDimensional",
    ThreeDimensional = "ThreeDimensional"
}